module.exports = __webpack_public_path__ + "img/n11png50px.3f7e0e54.png";